import React, { useEffect, useState } from 'react'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { connect, useDispatch } from 'react-redux'
import { userTokenSelector } from 'Store/customer/selector'
import { RootState } from 'Store'
import { Col, Dropdown, Input, Menu, Row, Space } from 'antd'
import { selectEventDashboard } from 'Store/dashboard/selector'
import { EventModal, LoadingView } from 'Components/modal'
import styled from 'styled-components'
import { QuaterPickerItem, RangeDateItem, SelectItem } from 'Components/form'
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons'
import { PrimaryButton } from 'Components/button'
import {
  currentDate,
  currentDateImport,
  getLast1Month,
  getMenuSelect,
  renderDateFormQuater,
  toDateQuery,
} from 'helpers/format'
import { cloneDeep } from 'lodash'
import CompareReport from './components/CompareReport'
import ManufacturingReport from './components/ManufacturingReport'
import PricingReport from './components/PricingReport'
import IngredientReport from './components/IngredientReport'
import ManufacPermonthReport from './components/ManufacPermonthReport'
import SummaryReport from './components/SummaryReport'
import ConfirmImport from 'Components/modal/ConfirmImport'
import { menuDateOptionFilter } from 'helpers/constanst'
import {
  getManufacturDashboardAPI,
  getMasterProductAPI,
  getMerchantSummaryDashboardAPI,
  uploadFileApi,
} from 'Store/minirmx-dashboard/api'
import { selectCurrentUser } from 'Store/user/selector'
import {
  selectActionEvent,
  selectManufacturDashboard,
  selectManufacturListevent,
  selectMasterProduct,
  selectMerchantSummaryDashboard,
  selectMerchantSummaryEvent,
} from 'Store/minirmx-dashboard/selector'
import { clearEventAction } from 'Store/minirmx-dashboard/actions'
import { ManufacturReq, MerchantSummaryReq } from 'Store/minirmx-dashboard/types'
import { Pagination } from 'Components/Pagination'
import InseeLogo from '../../assets/img/insee-logo.png'

type Props = {} & ReduxProps

const DashboardRmx: React.FunctionComponent<Props> = props => {
  const {
    event,
    currentUser,
    actionEvent,
    masterProducts,
    manufacturList,
    summaryData,
    listEvent,
    summayEvent,
  } = props
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const [importDailog, setImportDailog] = useState(false)
  const dispatch = useDispatch()

  const initFilter = {
    start_date: getLast1Month(),
    end_date: currentDate(),
    quarter: '',
    product: '',
    dateType: 'date',
  }

  const [filter, setFilter] = useState(cloneDeep(initFilter))
  const datas = manufacturList.data || []
  const meta = manufacturList.meta

  const onImportFile = (file: any): void => {
    const fmData = new FormData()
    fmData.append('csvfile', file)
    dispatch(uploadFileApi(fmData, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
  }

  const onGetMasterProducts = (): void => {
    dispatch(getMasterProductAPI({}, currentUser.accessToken))
  }

  const onGetManufacturDashboard = (): void => {
    const req: ManufacturReq = {
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      str_no: filter.product,
    }
    if (filter.dateType === 'date') {
      req.start_date = filter.start_date ? toDateQuery(filter.start_date) : ''
      req.end_date = filter.end_date ? toDateQuery(filter.end_date) : ''
    } else {
      if (filter.quarter) {
        const resultQuater = renderDateFormQuater(filter.quarter)
        req.start_date = resultQuater.startDate
        req.end_date = resultQuater.endDate
      }
    }
    dispatch(getManufacturDashboardAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
  }

  const onGetMerchantSummaryDashboard = (): void => {
    const req: MerchantSummaryReq = {
      str_no: filter.product,
    }
    if (filter.dateType === 'date') {
      req.start_date = filter.start_date ? toDateQuery(filter.start_date) : ''
      req.end_date = filter.end_date ? toDateQuery(filter.end_date) : ''
    } else {
      if (filter.quarter) {
        const resultQuater = renderDateFormQuater(filter.quarter)
        req.start_date = resultQuater.startDate
        req.end_date = resultQuater.endDate
      }
    }
    dispatch(
      getMerchantSummaryDashboardAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || 0),
    )
  }

  const onClickSearch = () => {
    onGetMerchantSummaryDashboard()
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetMasterProducts()
      onGetManufacturDashboard()
      onGetMerchantSummaryDashboard()
    }
  }, [])

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetManufacturDashboard()
    }
  }, [pagination])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const handleChangeDate = (statDate: string, endDate: string) => {
    setFilter({
      ...filter,
      start_date: statDate,
      end_date: endDate,
    })
  }

  const handleChangeQuater = (val: string) => {
    setFilter({
      ...filter,
      quarter: val,
    })
  }

  const FilterContent = (
    <FilterWrapper>
      <Row justify="start" align="bottom" gutter={[8, 8]}>
        <Col xs={24} md={5}>
          <SelectItem
            name={'dateType'}
            label={''}
            isRequired={true}
            value={filter.dateType}
            menu={menuDateOptionFilter}
            placeHolder={'ค้นหาด้วย'}
            onChange={(val: any): void => onFilter('dateType', val)}
          />
        </Col>
        <Col xs={24} md={8}>
          {filter.dateType === 'date' ? (
            <RangeDateItem
              placeHolder={['วันที่ซื้อเริ่มต้น', 'สิ้นสุด']}
              onChange={handleChangeDate}
              startDate={filter.start_date}
              endDate={filter.end_date}
            />
          ) : (
            <QuaterPickerItem
              placeHolder={'เลือกไตรมาส'}
              onChange={handleChangeQuater}
              date={filter.quarter}
            />
          )}
        </Col>
        <Col xs={24} md={8}>
          <SelectItem
            name={'product'}
            label={''}
            isRequired={true}
            value={filter.product}
            menu={getMenuSelect(masterProducts, 'class_cy', 'str_no')}
            placeHolder={'ผลิตภัณฑ์'}
            onChange={(val: any): void => onFilter('product', val)}
          />
        </Col>
        <Col>
          <PrimaryButton icon={<SearchOutlined />} text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
        </Col>
        <Col>
          {/* <Dropdown overlay={menuImport} placement="bottomCenter" arrow trigger={['click']}>
            <PrimaryButton
              icon={<DownloadOutlined />}
              text="นำเข้าไฟล์ (.csv)"
              btnType="Primary"
              key="import"
            />
          </Dropdown> */}
          <PrimaryButton
            icon={<DownloadOutlined />}
            text="นำเข้าไฟล์ (.csv)"
            btnType="Primary"
            key="import"
            onClick={() => {
              setImportDailog(true)
            }}
          />
        </Col>
      </Row>
    </FilterWrapper>
  )

  const ConfirmImportModal = (
    <ConfirmImport
      title={`นำเข้าไฟล์`}
      confirmBtnTxt="ยืนยันนำเข้า"
      description={`รูปแบบไฟล์ : นามสกุลไฟล์ที่รองรับ คือ .csv และ ชื่อไฟล์ที่ใช้ในการ Upload → FileName-MID-YYYYMMDD.csv (MINIRMX-${currentUser
        ?.activeMerchant?.id || 0}-${currentDateImport()}.csv)`}
      isShow={importDailog}
      handleOk={onImportFile}
      handleCancel={() => setImportDailog(false)}
      loading={actionEvent.IsLoading}
      key="confirm-import"
      mid={currentUser?.activeMerchant?.id || 0}
    />
  )

  // const UploadDeliveryLoadingModal = (
  //   <EventModal
  //     event={[uploadDeliveryEvent]}
  //     enable={importDeliveyDailog}
  //     successCalback={onUploadDeliverySuccess}
  //     errorCalback={clearEvent}
  //   />
  // )

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onUploadSuccess = (): void => {
    setImportDailog(false)
    clearEvent()
  }

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const logo = <img src={InseeLogo} width="200px" />
  const title = (
    <Space>
      แดชบอร์ด INSEE Mini RMX
      {logo}
    </Space>
  )

  return (
    <HomePageLayout selected="dashboard-rmx" title={title} bgColor="#fff">
      <LoadingView isShow={listEvent.IsLoading || summayEvent.IsLoading} />
      <EventModal
        event={[actionEvent]}
        enable={true}
        successCalback={onUploadSuccess}
        errorCalback={clearEvent}
      />
      {FilterContent}
      <Row gutter={[42, 42]}>
        <Col md={24} xs={24}>
          <SummaryReport data={summaryData?.total} />
        </Col>
        <Col md={24} xs={24}>
          <CompareReport data={datas} pagination={PaginationContent} />
        </Col>
        <Col md={12} xs={24}>
          <ManufacturingReport datas={summaryData?.productivity_by_product || []} />
        </Col>
        <Col md={12} xs={24}>
          <ManufacPermonthReport datas={summaryData?.productivity_by_month || []} />
        </Col>
        <Col md={12} xs={24}>
          <PricingReport datas={summaryData?.price || []} />
        </Col>
        <Col md={12} xs={24}>
          <IngredientReport datas={summaryData?.material || []} />
        </Col>
        {/* <Col md={12} xs={24}>
          <ManufacPermonthReport />
        </Col> */}
      </Row>
      {ConfirmImportModal}
    </HomePageLayout>
  )
}

const FilterWrapper = styled.div`
  padding: 10px 0 20px 0;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const mapStateToProps = (state: RootState) => {
  return {
    token: userTokenSelector(state),
    event: selectEventDashboard(state),
    actionEvent: selectActionEvent(state),
    currentUser: selectCurrentUser(state),
    masterProducts: selectMasterProduct(state),
    manufacturList: selectManufacturDashboard(state),
    summaryData: selectMerchantSummaryDashboard(state),
    listEvent: selectManufacturListevent(state),
    summayEvent: selectMerchantSummaryEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(DashboardRmx)
